import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-text font-weight-bold ms-1 mb-2" }
const _hoisted_2 = { class: "p-text font-weight-light ms-1 mb-2" }
const _hoisted_3 = { class: "p-text font-weight-light ms-1 mb-2" }
const _hoisted_4 = { class: "p-text font-weight-bold ms-1 mb-2" }

import { reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { productService } from '@/api/services/product';
import { useSettingsStore } from '@/api/store/settings';
import { useCartStore } from '@/api/store/cart';
import InfiniteScroll from "infinite-loading-vue3";
import debounce from 'lodash.debounce'

const SUPPLIER_INDEX = 1;


export default /*@__PURE__*/_defineComponent({
  __name: 'SuppliersIndex',
  setup(__props) {

const settingsStore = useSettingsStore();
const cartStore = useCartStore();

const router = useRouter();



const state = reactive({
    items: [] as any[],
    search_type: null as string | null,
    search_types: ["name", "brand"] as any[],
    search: "" as string,
    sort_asc: true as boolean,
    page: 1 as number,
});

const resetFilters = () => {
    state.search = "";
    state.search_type = null;
    state.sort_asc = true;
}

const sortItems = () => {
    if (state.sort_asc) {
        state.items.sort((a, b) => {
            return a.id - b.id;
        });
    } else {
        state.items.sort((a, b) => {
            return b.id - a.id;
        });
    }
}

const loadNextData = async () => {
    state.page += 1;
    
    let filters = "page=" + state.page;
    productService.index(2, filters).then((response) => {
        state.items.push(...response.data);
        
    });
};

const addProductToCart = (item: any) => {
    
    cartStore.addItem(1, item.id, 1).then((res: any) => {
        router.push({ name: 'shopping-cart' });
    }).catch((error: any) => {
        settingsStore.error = true;
        settingsStore.error_message = "This item may be out of stock or no longer available from the supplier."
    });
}

const loadItems = () => {
    productService.index(SUPPLIER_INDEX).then((response) => {
        state.items = response.data;
        
    });
}

const loadItemsWithFilter = debounce( (filter: string) => {
    
    productService.index(SUPPLIER_INDEX, filter).then((response) => {
        state.items = response.data;
        
    });
}, 1000)

const FilterItems = () => {

    let filters = "";
    const search_type = state.search_type == null || state.search_type == "name" ? "search" : state.search_type;

    if (state.search != "") {
        filters = search_type + "=" + state.search;
    }

    if (filters != "") {
        loadItemsWithFilter(filters);
    } else {
        
        loadItems();
    }
}

loadItems();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-1" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "my-0",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "mb-1 px-1",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: state.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.search) = $event)),
                variant: "solo",
                placeholder: "Search Products",
                density: "compact",
                rounded: "",
                "hide-details": "",
                onInput: FilterItems
              }, {
                "prepend-inner": _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "15",
                    color: "grey",
                    icon: "fa-search",
                    class: "mb-1"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "my-0 px-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: _unref(settingsStore).settings.buttonColor,
                class: "text-left text-white b-round-20",
                "prepend-icon": "fa-sort",
                width: "100%",
                rounded: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (state.sort_asc = !state.sort_asc))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Sort ", -1)
                ]))]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "my-0 px-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "b-round-20 text-white",
                "prepend-icon": "fa-filter",
                color: _unref(settingsStore).settings.buttonColor,
                width: "100%",
                onClick: resetFilters
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("small", null, "Clear Filters", -1)
                ]))]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(InfiniteScroll), { onInfiniteScroll: loadNextData }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "px-2 mt-1",
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  class: "pa-1",
                  key: item.id,
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "mx-auto pt-2 px-2",
                      "max-width": "300",
                      height: "250",
                      onClick: ($event: any) => (_unref(router).push({ name: 'supplier-product', params: { id: item.id } }))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          width: "100",
                          height: "100",
                          src: item.images[0]?.full,
                          cover: "",
                          class: "mt-1 mx-auto text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "flat",
                              size: "40",
                              onClick: _withModifiers(($event: any) => (addProductToCart(item)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: "fa fa-cart-plus",
                                  color: _unref(settingsStore).settings.buttonColor,
                                  size: "20"
                                }, null, 8, ["color"])
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["src"]),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(item.name), 1),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(item.brand.name), 1),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(item.sku), 1),
                            _createElementVNode("div", _hoisted_4, " £" + _toDisplayString(item.price.toFixed(2)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})